import { GenericService } from '@/services/api/generic.service';
import { Domain } from '@/models';

export class DomainService extends GenericService<Domain> {
  constructor() {
    super('v1/domains');
  }
}
